module.exports = __webpack_public_path__ + "media/images/profile_icon-1b724e7bcb6b670c77df5a30d0142d03.svg";